import { API_HOST, STORAGE_KEY } from "@/lib/config"

const API_BASE = `${API_HOST}/api/v1/geomaster`

function getAuthHeaders(): HeadersInit {
  const headers: HeadersInit = {}
  const token = localStorage.getItem(STORAGE_KEY)
  if (token) {
    ;(headers as Record<string, string>).Authorization = `Bearer ${token}`
  }
  return headers
}

async function handleResponse<T>(response: Response): Promise<T> {
  if (response.status === 401) {
    localStorage.removeItem(STORAGE_KEY)
    window.location.hash = "#/login"
    throw new Error("会话已过期，请重新登录")
  }
  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}))
    throw new Error(errorData.detail || "请求失败")
  }
  return response.json()
}

export interface GeomasterLLMConfig {
  model_name?: string
  base_url?: string
  temperature?: number
  max_repair_rounds?: number
}

export interface GeomasterGenerateRequest {
  problem_text?: string
  image_url?: string
  llm?: GeomasterLLMConfig
}

export interface GeomasterValidationResult {
  valid: boolean
  errors: string[]
  repair_rounds: number
}

export interface GeomasterGenerateResponse {
  dsl: Record<string, any>
  validation: GeomasterValidationResult
  meta: Record<string, any>
  warnings: string[]
}

export interface GeomasterCompileResult {
  script: string
  diagnostics: string[]
}

export interface GeomasterCompileResponse {
  geogebra: GeomasterCompileResult
  jsxgraph: GeomasterCompileResult
}

export async function generateGeomasterDsl(
  payload: GeomasterGenerateRequest,
): Promise<GeomasterGenerateResponse> {
  const response = await fetch(`${API_BASE}/generate-dsl`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getAuthHeaders(),
    },
    body: JSON.stringify(payload),
  })
  return handleResponse(response)
}

export async function compileGeomasterDsl(
  dsl: Record<string, any>,
): Promise<GeomasterCompileResponse> {
  const response = await fetch(`${API_BASE}/compile-dsl`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getAuthHeaders(),
    },
    body: JSON.stringify({ dsl }),
  })
  return handleResponse(response)
}
